// extracted by mini-css-extract-plugin
module.exports = {"container":"ParentTrails_container__CxN_7","iconContainer":"ParentTrails_iconContainer__Ekn8h"};